/**
 * Locale Configuration Constants - SINGLE ENTRY POINT for locale constants - "barrel file").
 * Re-exports static constants, derived constants, and RMS default data.
 * No circular dependency: this file does not import from locale-config.types.
 */

export { DEFAULT_RMS_REGION_DATA } from './rms-data'

export {
  LOCALE_COOKIE,
  REGION_DETAILS_LOCAL_STORAGE_KEY,
  LOCALE_FORMAT,
  LOCALE_FORMAT_STANDARD,
  DEFAULT_LOCALE,
  DEFAULT_LANGUAGE,
  DEFAULT_LOCALE_PREFIX,
  FALLBACK_REGION_ID,
  DEFAULT_LANGUAGE_CODE,
  SWATCH_ORDERING_COUNTRIES,
} from './locale-config.static-constants'

export {
  SUPPORTED_COUNTRIES,
  COUNTRY_CURRENCIES,
  CURRENCY_TO_REGION_ID,
  COUNTRY_LANGUAGES,
  DEFAULT_COUNTRY,
  formatLocale,
  FALLBACK_LOCALE,
  COUNTRY_CONFIG,
  LOCALE_STANDARD_FORMAT,
  SUPPORTED_LOCALES,
  toNormalisedLocale,
  COUNTRY_REGION_IDS,
} from './locale-config.derived-constants'
